//document ready
$(function () {
    var oldFlickityCreate = window.Flickity.prototype._create;

    window.Flickity.prototype._create = function () {
        var that = this;
        if (this.element.addEventListener) {
            this.element.addEventListener('load', function () {
                that.onresize();
            }, true);
        }
        this._create = oldFlickityCreate;
        return oldFlickityCreate.apply(this, arguments);
    };

    objectFitImages();
    header.loadMegaMenu();
    header.init();
    
    searchAutocomplete.init();
    
    collectionsSliderSection.init();
    utils.pageBannerCheck();
    slideshow.init();
    testimonial.init();
    videoSection.init();
    gallery.init();
    featuredPromotions.init();
    featuredCollectionSection.init();
    logoBarSection.init();
    collectionPreviewSection.init();
    collectionSidebarFilter.init();
    cart.init();
    mapFunction.init();
    productPage.initializeQuantityBox();
    productPage.init();

    recentlyViewed.init();
    //restrictLicenses();
    $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function (cart) {
            updateCartPage(cart);
        }
    });


    // Setup a timer
    var resizeTimeout;

    // Listen for resize events
    window.addEventListener('resize', function (event) {

        // If timer is null, reset it to 66ms and run your functions.
        // Otherwise, wait until timer is cleared
        if (!resizeTimeout) {
            resizeTimeout = setTimeout(function () {

                // Reset timeout
                resizeTimeout = null;

                // Run our resize functions
                if ($(window).width() <= 798) {
                    cart.init();
                    header.unload();
                    header.init();
                }

            }, 66);
        }
    }, false);

    //Lightbox default options
    //https://fancyapps.com/fancybox/3/docs/#options
    $.fancybox.defaults.animationEffect = 'fade';
    $.fancybox.defaults.transitionEffect = 'fade';
    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.infobar = false;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.arrows = false;
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.smallBtn = true;
    $.fancybox.defaults.live = false;
    $.fancybox.defaults.zoom = false;
    $.fancybox.defaults.mobile.preventCaptionOverlap = false;
    $.fancybox.defaults.mobile.toolbar = true;
    $.fancybox.defaults.mobile.buttons = ['close'];
    $.fancybox.defaults.mobile.clickSlide = 'close';
    $.fancybox.defaults.mobile.clickContent = 'zoom';
    $.fancybox.defaults.afterLoad = function (instance, slide) {
        if (instance.current.type == 'image') {
            slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>")
        }
        if (instance.group.length > 1) {
            slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>' + svgArrowSizeLeft + '</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>' + svgArrowSizeRight + '</span></a>')
        }
    }

    //backwards compatibility with custom lightboxes
    $('.lightbox[rel="gallery"]').fancybox();

    //Search input hiding
    //get current input
    var currentValue = $(".search_form input[name='q']").val()
    //return amount without *
    if ($(".search_form input[name='q']").length > 0) {
        $(".search_form input[name='q']").val(currentValue.replace('*', ''));
    }

    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body')
        .on('change', '#tag_filter, #sort-by', function () {
            quickFilter.init();
        });

    $('body')
        .on('change', '#blog_filter', function () {
            var url = $(this).val();
            window.location = url;
        });

    $('input, select, textarea').on('focus blur', function (event) {
        $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
    });

    //Collection sidebar filter
    //Check the checkbox values
    $('body').on('change', '[data-option-filter] input', function () {
        quickFilter.init();
        $("html, body").animate({
            scrollTop: ($('#pagecontent').offset().top)
        }, 500);
    })

    $('body').on('click', '[data-reset-filters]', function () {
        collectionSidebarFilter.clearAllFilters();
    });

    $('body').on('click', '[data-clear-filter]', function () {
        var selectedOption = $(this).parents('.filter-active-tag');
        collectionSidebarFilter.clearSelectedFilter(selectedOption);
    });

    $('body').on('change', '.currencies', function (e) {
        $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
    });

    $('body').on('change', '.js-quick-shop select', function (e) {
        var currentVariant = $('.js-quick-shop select[name="id"]').val();
        if (currentVariant && globalQuickShopProduct) {
            quickShop.updateVariant(currentVariant);
        }
    });

    

    var touchStartPos = 0;

    //Detecting swipe vs tap
    $(document).bind("touchstart", function (e) {
        touchStartPos = $(window).scrollTop();
    }).bind("touchend", function (e) {
        var distance = touchStartPos - $(window).scrollTop();
        if (distance > 20 || distance < -20) {
            e.preventDefault;
        }
    });

    $('body').on('click', '.sidebar .parent-link--false', function (e) {
        e.preventDefault();
        $menu = $(this).parent('li');
        $menu.find('.menu-toggle').toggleClass('active');
        $menu.find('ul').slideToggle();
    });

    

    if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top - 140}, 'slow');
    }

    $('body').on('mouseenter', '.icon-search', function () {
        $('.search-terms').focus();
    });

    $('body').on('click', '.icon-search', function () {
        $('input.search-terms').focus();
    });

    $('body').on('click', '.search-submit', function () {
        $(this).parent().submit();
    });

    if ($(window).width() > 798) {
        $(".animate_right").waypoint(function () {
            $(this.element).addClass("animated fadeInRight");
        }, {offset: '70%'});
        $(".animate_left").waypoint(function () {
            $(this.element).addClass("animated fadeInLeft");
        }, {offset: '70%'});
        $(".animate_up").waypoint(function () {
            $(this.element).addClass("animated fadeInUp");
        }, {offset: '70%'});
        $(".animate_down").waypoint(function () {
            $(this.element).addClass("animated fadeInDown");
        }, {offset: '70%'});
    }

    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
        pageDots: usePageDots,
        imagesLoaded: true,
        arrowShape: arrowSize,
        lazyLoad: 2
    });

    utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
    utils.createAccordion('.footer_menu', 'h6', 'ul');
    utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
    utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

    utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
    utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

    utils.initializeTabs();
    faqAccordion.init();

    //Sidebar toggle check
    if ($(window).width() <= 798) {
        utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
    }

    $('body').on('click', '.menu-toggle', function (e) {
        var $content = $(this).next('ul');
        $content.slideToggle();
        $(this).toggleClass('active');
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
    });

    if ($(window).width() >= 959) {
        var modal_width = '870px';
        if ($(window).width() >= 1200 || $('html').hasClass('ie')) {
            modal_width = '1110px'
        }
    }

    

    //Terms of service settings for minicart
    

    $("#clear_cart").on("click", function (e) {
        console.log("hello");
        if (confirm("Are you sure you want to empty the cart?")) {
            window.location.href = '/cart/clear';
        }
    });

    


    
    imageFunctions.showSecondaryImage();
    

    var $contact_form = $('.newsletter .contact-form');
    $contact_form.each(function () {
        var $cf = $(this);
        $cf.on('submit', function (e) {
            if ($('input[name="challenge"]', $cf).val() !== "true") {
                $.ajax({
                    type: $cf.attr('method'),
                    url: $cf.attr('action'),
                    data: $cf.serialize(),
                    success: function (data) {
                        $cf.fadeOut("slow", function () {
                            $cf.prev('.message').html("Thank you for joining our mailing list!");
                        });
                    },
                    error: function (data) {
                        $('input[name="challenge"]', $cf).val('true');
                        $cf.submit();
                    }
                });
                e.preventDefault();
            }
        });
    });

    $('.maps').click(function () {
        $('.maps iframe').css("pointer-events", "auto");
    });

    
    enableLoadMoreProducts();
    

    

    

    

    /*============================================================================
      Start of cart-related functionality
    ==============================================================================*/

    function ajaxSubmitCart(cart) {
        $cart = cart;
        $.ajax({
            url: '/cart/update.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: $cart.serialize(),
            success: function (data) {
                refreshCart(data);
            }
        });
    }

    function ajaxUpdateCart(lineID, quantity, parent) {
        $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: {quantity: quantity, line: lineID},
            success: function (data) {
                refreshCart(data);

                var lineIDIndex = lineID - 1;

                //check to see if there are correct amount of products in array
                if (typeof data.items[lineIDIndex] === "undefined") {
                    var updated_quantity = 0;
                } else {
                    var updated_quantity = data.items[lineIDIndex].quantity;
                }

                if (quantity > 0 && quantity != updated_quantity) {
                    if (updated_quantity == 1) {
                        items_left_text = "item left";
                    } else {
                        items_left_text = "items left";
                    }

                    $('.warning--quantity').remove();

                    var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
                    parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
                    parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
                } else if (parent.is('#cart_form')) {
                    $("#cart_form").submit();
                }
            }
        });
    }

    function handleAjaxRecommendedProducts(form) {
        const $addToCartForm = $(form);
        var $addToCartBtn = $addToCartForm.find('.add_to_cart');
        let selectedVariantId = $($addToCartForm).find('.swatch input:checked+.swatch-element').attr('data-id');

        if (!selectedVariantId) {
            selectedVariantId = $($addToCartForm).find('[name="id"]').val();
        }

        const quantity = 1;

        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: {
                id: selectedVariantId,
                quantity: quantity
            },
            beforeSend: function () {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
            },
            success: function (itemData) {
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                window.setTimeout(function () {
                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                    $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                    $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                }, 1000);

                $.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    success: function (cart) {
                        refreshCart(cart);
                        var $cart_container = $('[data-mini-cart-container]');
                        $('html').addClass('is--locked');
                        $('.dropdown_link').removeClass('active_link');
                        $cart_container.addClass('active_link').addClass('open_cart_mini');

                        if ($('body').hasClass('fancybox-active')) {
                            $.fancybox.close();
                        }
                    }
                });
            },
            error: function (XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                $('.warning').remove();

                var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
            }
        });
    }
    function checkCheckoutPosition($form) {
        var $parent = $('.js-subtotal').parents('.js-cart-row');
        var $sticky = $('.js-subtotal');
        var top = $parent.offset().top;
        var bottom = $parent.outerHeight() + top - 30;
        var scroll = $(window).scrollTop() + $(window).height();
        if (scroll > top && scroll < bottom) {
            $sticky.parent().css('min-height', $sticky.outerHeight());
            $sticky.css('left', $sticky.parent().offset().left).css('width', $sticky.parent().outerWidth());
            $sticky.addClass('is-fixed');
        } else {
            $sticky.css('left', '').css('width', '');
            $sticky.parent().css('min-height', '');
            $sticky.removeClass('is-fixed');

        }
    }
    function refreshCart(cart) {
        $(".cart_count").empty();
        $cartBtn = $(".cart_count");
        var value = $(cart).find('.top_bar--right .cart_count').html();
        if ($(cart).find('.js-cart-holder').length > 0) {
            $('.js-cart-holder').html($(cart).find('.js-cart-holder').html())
        }

        $cartBtn.html(value);
    }

    $('body').on("change", "#cart_form input.quantity", function () {
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
    });

    $('body').on("change", ".cart_content input.quantity", function () {
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
    });

    $('body').on("click", "[data-remove-line]", function () {
        $(this).closest('.cart_item').addClass('animated fadeOutUp');
        ajaxUpdateCart($(this).data('remove-line'), 0, $(this).parents('.cart_content'));
    });

    
    $('body').on('click', '.add_to_cart--sticky', function (e) {
        
        var $addToCartForm = $(this).parents('form');
        var swatch = $addToCartForm.find('.swatch-size');
        if (swatch.length > 0) {
            var selectSize = swatch.find(':radio:checked');
            if (selectSize.length === 0) {
                $("html, body").animate({
                    scrollTop: ($('.swatch-size').offset().top - 50)
                }, 500);
            }
        }
        
    });
    $('body').on('input', ".js-add-to-cart-qty-variant", function (e) {
        $(this).removeClass('has-error');
    });

    var time = false;
    $('body').on('submit', ".product_form form, .shopify-product-form", function (e) {
        e.preventDefault();
        if ($($(this).parent()).hasClass('recommended-purchase-form')) {
            handleAjaxRecommendedProducts($(this));
            return;
        }
        var $addToCartForm = $(this);
        var $addToCartBtn = $addToCartForm.find('.add_to_cart');
        
        var swatch = $addToCartForm.find('.swatch-size');
        if (swatch.length > 0) {
            var selectSize = swatch.find(':radio:checked');
            if (selectSize.length === 0) {
                $('.swatch-notice').fadeIn(200);
                return;
            }
        }
        
        var data = $addToCartForm.serialize();
        var swatchWithQty = $addToCartForm.find('.js-add-to-cart-qty-variant');
        var items = [];
        var items2 = [];
        if (swatchWithQty.length > 0) {
            swatchWithQty.each(function () {
                var val = $(this).val();
                var dataId = $(this).data('id');
                var productId = $(this).data('product-id');
                if (val > 0) {
                    items.push({
                        quantity: parseInt(val, 10),
                        id: parseInt(dataId, 10),
                        product_id: parseInt(productId, 10)
                    });
                    items2.push({
                        name: $(this).data('name'),
                        id: parseInt(dataId, 10),
                        product_id: parseInt(productId, 10),
                        el: $(this)
                    });
                }
            });
            data = {
                items: items
            };
        }


        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: data,
            beforeSend: function () {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
            },
            success: function (itemData) {
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                window.setTimeout(function () {
                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                    $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                    $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                    if ($('.js-add-to-cart-qty-variant').length > 0) {
                        $('.js-add-to-cart-qty-variant').val('');
                    }
                }, 1000);

                $.ajax({
                    url: '/cart',
                    cache: false,
                    success: function (cart) {
                        refreshCart(cart);

                        $('.js-cart-holder .js-cart-product').hide();
                        $('.js-cart-holder .js-cart-product[data-product="' + items[0].product_id + '"]').show();

                        $('.warning').remove();
                        var $cart_container = $('[data-mini-cart-container]');

                        clearTimeout(time);
                        setTimeout(function () {
                            $('.dropdown_link').removeClass('active_link');
                            $cart_container.addClass('active_link').addClass('open_cart_mini');
                            if ($('body').hasClass('fancybox-active')) {
                                $.fancybox.close();
                            }

                        }, 100);
                        time = setTimeout(function () {
                            $cart_container.addClass('active_link').removeClass('open_cart_mini');
                        }, 5000);
                        var $qt = $('.js-add-to-cart-qty-variant');
                        if ($qt.length > 0) {
                            for (var i = 0; i < items.length; i++) {
                                var $qt = $('.js-add-to-cart-qty-variant[data-id="' + items[i].id + '"]');
                                var count = parseInt($qt.attr('max'), 10) - items[i].quantity;
                                $qt.attr('max', count);
                                if (count < 1) {
                                    $qt.parents('.swatch-element__wrapper').removeClass('swatch-element__wrapper--limited-stock').addClass('swatch-element__wrapper--disabled');
                                    $qt.attr('disabled', 'disabled')
                                }
                            }
                        }


                    }
                });
            },
            error: function (XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                $('.warning').remove();

                for (var i = 0; i < items2.length; i++) {
                    if (response.indexOf(' - ' + items2[i].name + ' ') !== -1) {
                        items2[i].el.addClass('has-error');
                    }
                }

                var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
            }
        });

        return false;
    });
    

    productPage.productSwatches();
    productPage.relatedProducts();


    //Cart

    var isChange = false;

    function updateCartPage(data) {

        if (data.item_count > 0) {
            $('.js-cart-empty').addClass('is-hidden');
            $('.js-cart-form').removeClass('is-hidden');
        } else {
            $('.js-cart-empty').removeClass('is-hidden');
            $('.js-cart-form').addClass('is-hidden');
        }
        $('.js-cart-qty').attr('data-item', 0).val('');
        var total = {};
        var productFinalPrices = {};
        console.log(data.items);
        let quantity = 0;
        for (var i = 0; i < data.items.length; i++) {
            if (!(data.items[i].product_id in productFinalPrices)) {
                productFinalPrices[data.items[i].product_id] = data.items[i].final_line_price;
                let productPrice = parseFloat($('.product-price-' + data.items[i].product_id).data('price'));
                if (productPrice > 0) {
                    productFinalPrices[data.items[i].product_id] = productPrice;
                }
            }

            if ((data.items[i].product_id) in total) {
                total[data.items[i].product_id] += productFinalPrices[data.items[i].product_id] * data.items[i].quantity;
            } else {
                total[data.items[i].product_id] = productFinalPrices[data.items[i].product_id] * data.items[i].quantity;
            }

            var itemEl = $('.js-cart-qty[data-id="' + data.items[i].variant_id + '"]');
            if (itemEl.length > 0) {
                quantity += data.items[i].quantity;
                itemEl.val(data.items[i].quantity);
                itemEl.attr('data-item', data.items[i].id);
            }
        }
        console.log(total);
        console.log(productFinalPrices);

        let totalAmount = 0;
        for (var i in total) {
            var price = $('.js-cart-product-total[data-product-id="' + i + '"]');
            if (price.length > 0) {
                price.text(Shopify.formatMoney(total[i], $('body').data('money-format')));
            }
            totalAmount += total[i];
        }

        $('#total-units-js').html(quantity);
        $('#total-price-js').html(Shopify.formatMoney(totalAmount, $('body').data('money-format')));
        isChange = false;
        $('.js-cart-qty').removeAttr('disabled');
    }

    $('body').on('click', '.js-cart-product-remove', function (e) {
        e.preventDefault();
        var parent = $(this).parents('.js-cart-product');
        if (parent.length > 0) {
            var el = parent.find('.js-cart-qty');
            var items = {};
            el.each(function () {
                var id = parseInt($(this).attr('data-item'), 10);
                if (id != 0) {
                    items[id] = 0;
                }
            });

            $('.js-cart-qty').attr('disabled', 'disabled');
            isChange = true;
            $.ajax({
                url: '/cart/update.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: {
                    updates: items
                },
                success: function (data) {
                    if (data.item_count > 0) {
                        $('.js-cart-empty').addClass('is-hidden');
                        $('.js-cart-form').removeClass('is-hidden');
                    } else {
                        $('.js-cart-empty').removeClass('is-hidden');
                        $('.js-cart-form').addClass('is-hidden');
                    }
                    parent.remove();
                    isChange = false;
                    $('.js-cart-qty').removeAttr('disabled');
                    var $form = $('.js-cart-row');
                    if ($form.length > 0) {
                        checkCheckoutPosition($form);
                    }
                },
                error: function (XMLHttpRequest) {
                    qty.val(val);
                    var response = eval('(' + XMLHttpRequest.responseText + ')');

                    isChange = false;
                    $('.js-cart-qty').removeAttr('disabled');
                }
            });
        }
    });
    $('body').on('change', '.js-cart-qty', function (e) {
        $('.warning').remove();
        if (isChange === false) {
            var qty = $(this);
            var val = qty.val();
            var max = parseInt(qty.attr('max'), 10);
            if (val > max) {
                val = max;
                $('.warning').remove();
                var name = qty.attr('data-name-variant');
                var text = 'You can add only {{count}} {{name}} in your cart.';
                text = text.split("{").join("/").split("}").join("/")
                text = text.replace('//name//', name).replace('//count//', max).replace('// name //', name).replace('// count //', max);
                var warning = '<p class="warning animated bounceIn">' + text + '</p>';
                qty.parents('.swatch').after(warning);
            }
            if (val === '') {
                val = 0;
            }
            var dataId = qty.attr('data-item');

            $('.js-cart-qty').attr('disabled', 'disabled');
            isChange = true;
            if (dataId != 0) {
                $.ajax({
                    url: '/cart/change.js',
                    dataType: 'json',
                    cache: false,
                    type: 'post',
                    data: {
                        quantity: parseInt(val, 10),
                        id: parseInt(dataId, 10)
                    },
                    success: function (data) {
                        updateCartPage(data);
                    },
                    error: function (XMLHttpRequest) {
                        qty.val(val);
                        var response = eval('(' + XMLHttpRequest.responseText + ')');
                        isChange = false;
                        $('.js-cart-qty').removeAttr('disabled');
                    }
                });
            } else {
                var data = {
                    items: [{
                        quantity: parseInt(val, 10),
                        id: parseInt($(this).data('id'), 10)
                    }]
                };
                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    cache: false,
                    type: 'post',
                    data: data,
                    beforeSend: function () {
                    },
                    success: function (data) {
                        setTimeout(function () {
                            $.ajax({
                                url: '/cart.js',
                                dataType: "json",
                                cache: false,
                                success: function (cart) {
                                    updateCartPage(cart);
                                }
                            });
                        }, 100);


                    },
                    error: function (XMLHttpRequest) {
                        qty.val(val);
                        var response = eval('(' + XMLHttpRequest.responseText + ')');
                        response = response.description;
                        $('.warning').remove();
                        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                        qty.parents('.swatch').after(warning);
                        isChange = false;
                        $('.js-cart-qty').removeAttr('disabled');
                        setTimeout(function () {
                            $.ajax({
                                url: '/cart.js',
                                dataType: "json",
                                cache: false,
                                success: function (cart) {
                                    updateCartPage(cart);
                                }
                            });
                        }, 100);
                    }
                });
            }
        }
    });

    function checkMaxQty($el) {
        $('.warning').remove();
        var val = parseInt($el.val(), 10);
        var max = parseInt($el.attr('max'), 10);
        if (val > max) {
            $el.val(max);
            $('.warning').remove();
            var name = $el.attr('data-title');
            var text = 'You can add only {{count}} {{name}} in your cart.';
            text = text.split("{").join("/").split("}").join("/")
            text = text.replace('//name//', name).replace('//count//', max).replace('// name //', name).replace('// count //', max);
            var warning = '<p class="warning animated bounceIn">' + text + '</p>';
            $el.parents('.swatch__wrapper').after(warning);
        }
    }

    $('body').on('click', '.js-minus', function (e) {
        e.preventDefault();
        var el = $($(this).data('id'));
        if (el.length > 0) {
            var elVal = el.val();
            if (elVal == '') {
                elVal = 0;
            }
            var val = parseInt(elVal, 10) - 1;
            if (val < 0) {
                val = 0;
            }
            el.val(val);
            if ($(this).hasClass('is-update')) {
                el.trigger('change');
            } else {
                checkMaxQty(el);
            }
        }
    });
    $('body').on('click', '.js-plus', function (e) {
        e.preventDefault();
        var el = $($(this).data('id'));
        if (el.length > 0) {
            var elVal = el.val();
            if (elVal == '') {
                elVal = 0;
            }
            var val = parseInt(elVal, 10) + 1;
            if (val < 0) {
                val = 0;
            }
            el.val(val);
            if ($(this).hasClass('is-update')) {
                el.trigger('change');
            } else {
                checkMaxQty(el);
            }
        }
    });

    $('body').on('change', '.js-add-to-cart-qty-variant', function (e) {
        checkMaxQty(el);
    });



    var $form = $('.js-cart-row');
    if ($form.length > 0) {
        $(window).scroll(function () {
            checkCheckoutPosition($form);
        });
        $(window).resize(function () {
            checkCheckoutPosition($form);
        });
    }
});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function (selectorIndex, parent) {

    switch (selectorIndex) {
        case 0:
            var key = 'root';
            var selector = $(parent + ' .single-option-selector:eq(0)');
            break;
        case 1:
            var key = $(parent + ' .single-option-selector:eq(0)').val();
            var selector = $(parent + ' .single-option-selector:eq(1)');
            break;
        case 2:
            var key = $(parent + ' .single-option-selector:eq(0)').val();
            key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
            var selector = $(parent + ' .single-option-selector:eq(2)');
    }
    $('.swatch-notice').fadeOut(200);
    var availableOptions = Shopify.optionsMap[key];
    $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
        if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
        }
        else {
            $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
        }
    });

};

Shopify.linkOptionSelectors = function (product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
            // Gathering values for the 1st drop-down.
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
            Shopify.optionsMap['root'].push(variant.option1);
            Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
        }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function () {
        Shopify.updateOptionsInSelector(1, parent);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function () {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
};

//Used for cart functionality
function htmlEncode(value) {
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
};

/* option_selection.js */
function floatToString(t, e) {
    var o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? "0" + o : o
}if ("undefined" == typeof Shopify) var Shopify = {};Shopify.each = function (t, e) {
    for (var o = 0; o < t.length; o++) e(t[o], o)
}, Shopify.map = function (t, e) {
    for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
    return o
}, Shopify.arrayIncludes = function (t, e) {
    for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
    return !1
}, Shopify.uniq = function (t) {
    for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e
}, Shopify.isDefined = function (t) {
    return "undefined" == typeof t ? !1 : !0
}, Shopify.getClass = function (t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}, Shopify.extend = function (t, e) {
    function o() {
    }

    o.prototype = e.prototype, t.prototype = new o, t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype
}, Shopify.locationSearch = function () {
    return window.location.search
}, Shopify.locationHash = function () {
    return window.location.hash
}, Shopify.replaceState = function (t) {
    window.history.replaceState({}, document.title, t)
}, Shopify.urlParam = function (t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}, Shopify.newState = function (t, e) {
    var o;
    return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash()
}, Shopify.setParam = function (t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}, Shopify.Product = function (t) {
    Shopify.isDefined(t) && this.update(t)
}, Shopify.Product.prototype.update = function (t) {
    for (property in t) this[property] = t[property]
}, Shopify.Product.prototype.optionNames = function () {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}, Shopify.Product.prototype.optionValues = function (t) {
    if (!Shopify.isDefined(this.variants)) return null;
    var e = Shopify.map(this.variants, function (e) {
        var o = "option" + (t + 1);
        return void 0 == e[o] ? null : e[o]
    });
    return null == e[0] ? null : Shopify.uniq(e)
}, Shopify.Product.prototype.getVariant = function (t) {
    var e = null;
    return t.length != this.options.length ? e : (Shopify.each(this.variants, function (o) {
        for (var i = !0, r = 0; r < t.length; r++) {
            var n = "option" + (r + 1);
            o[n] != t[r] && (i = !1)
        }
        return 1 == i ? void(e = o) : void 0
    }), e)
}, Shopify.Product.prototype.getVariantById = function (t) {
    for (var e = 0; e < this.variants.length; e++) {
        var o = this.variants[e];
        if (t == o.id) return o
    }
    return null
}, Shopify.money_format = "$", Shopify.formatMoney = function (t, e) {
    function o(t, e) {
        return "undefined" == typeof t ? e : t
    }

    function i(t, e, i, r) {
        if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
        t = (t / 100).toFixed(e);
        var n = t.split("."), a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i), s = n[1] ? r + n[1] : "";
        return a + s
    }

    "string" == typeof t && (t = t.replace(".", ""));
    var r = "", n = /\{\{\s*(\w+)\s*\}\}/, a = e || this.money_format;
    switch (a.match(n)[1]) {
        case"amount":
            r = i(t, 2);
            break;
        case"amount_no_decimals":
            r = i(t, 0);
            break;
        case"amount_with_comma_separator":
            r = i(t, 2, ".", ",");
            break;
        case"amount_with_apostrophe_separator":
            r = i(t, 2);
            break;
        case"amount_no_decimals_with_comma_separator":
            r = i(t, 0, ".", ",")
    }
    return a.replace(n, r)
}, Shopify.OptionSelectors = function (t, e) {
    return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {
    }, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
}, Shopify.OptionSelectors.prototype.initDropdown = function () {
    var t = {initialLoad: !0}, e = this.selectVariantFromDropdown(t);
    if (!e) {
        var o = this;
        setTimeout(function () {
            o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t)
        })
    }
}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) {
    this.selectors[0].element.onchange(t)
}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) {
    var e = this.selectVariantFromParams(t);
    e || this.selectVariantFromDropdown(t)
}, Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
    var e = document.getElementById(t), o = e.parentNode;
    Shopify.each(this.buildSelectors(), function (t) {
        o.insertBefore(t, e)
    }), e.style.display = "none", this.variantIdField = e
}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1;
    var o = e.value;
    return this.selectVariant(o, t)
}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}, Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
    var o = this.product.getVariantById(t);
    if (null == o) return !1;
    for (var i = 0; i < this.selectors.length; i++) {
        var r = this.selectors[i].element, n = r.getAttribute("data-option"), a = o[n];
        null != a && this.optionExistInSelect(r, a) && (r.value = a)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0
}, Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) {
    for (var o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0
}, Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var o = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function (t) {
        o.appendChild(t)
    })
}, Shopify.OptionSelectors.prototype.buildSelectors = function () {
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
        e.element.disabled = !1, this.selectors.push(e)
    }
    var o = this.selectorDivClass, i = this.product.optionNames(), r = Shopify.map(this.selectors, function (t) {
        var e = document.createElement("div");
        if (e.setAttribute("class", o), i.length > 1) {
            var r = document.createElement("label");
            r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r)
        }
        return e.appendChild(t.element), e
    });
    return r
}, Shopify.OptionSelectors.prototype.selectedValues = function () {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var o = this.selectors[e].element.value;
        t.push(o)
    }
    return t
}, Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
    var o = this.selectedValues(), i = this.product.getVariant(o);
    i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e)
}, Shopify.OptionSelectorsFromDOM = function (t, e) {
    var o = e.optionNames || [], i = e.priceFieldExists || !0, r = e.delimiter || "/",
        n = this.createProductFromSelector(t, o, i, r);
    e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
    if (!Shopify.isDefined(o)) var o = !0;
    if (!Shopify.isDefined(i)) var i = "/";
    var r = document.getElementById(t), n = r.childNodes, a = (r.parentNode, e.length), s = [];
    Shopify.each(n, function (t, r) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
            0 == e.length && (a = n.length - (o ? 1 : 0));
            var p = n.slice(0, a), l = o ? n[a] : "", c = (t.getAttribute("value"), {
                available: t.disabled ? !1 : !0,
                id: parseFloat(t.value),
                price: l,
                option1: p[0],
                option2: p[1],
                option3: p[2]
            });
            s.push(c)
        }
    });
    var p = {variants: s};
    if (0 == e.length) {
        p.options = [];
        for (var l = 0; a > l; l++) p.options[l] = "option " + (l + 1)
    } else p.options = e;
    return p
}, Shopify.SingleOptionSelector = function (t, e, o, i) {
    this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select");
    for (var r = 0; r < i.length; r++) {
        var n = document.createElement("option");
        n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function (o, i) {
        i = i || {}, t.updateSelectors(e, i)
    }, !0
}, Shopify.Image = {
    preload: function (t, e) {
        for (var o = 0; o < t.length; o++) {
            var i = t[o];
            this.loadImage(this.getSizedImageUrl(i, e))
        }
    }, loadImage: function (t) {
        (new Image).src = t
    }, switchImage: function (t, e, o) {
        if (t && e) {
            var i = this.imageSize(e.src), r = this.getSizedImageUrl(t.src, i);
            o ? o(r, t, e) : e.src = r
        }
    }, imageSize: function (t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    }, getSizedImageUrl: function (t, e) {
        if (null == e) return t;
        if ("master" == e) return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
            var i = t.split(o[0]), r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r)
        }
        return null
    }, removeProtocol: function (t) {
        return t.replace(/http(s)?:/, "")
    }
}, Shopify.OptionSelectors.HistoryState = function (t) {
    this.browserSupports() && this.register(t)
}, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
    window.addEventListener("popstate", function (e) {
        t.selectVariantFromParamsOrDropdown({popStateCall: !0})
    })
}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) {
    this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id))
}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
    return window.history && window.history.replaceState
};

$(document)
    .on('shopify:block:select', function (e) {

        var blockId = e.detail.blockId;
        var $parentSection = $('#shopify-section-' + e.detail.sectionId);

        if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
            sliderBlock.select(blockId, $parentSection);
        }

        if ($parentSection.hasClass('page-details-section')) {
            if ($('.map-section').length) {
                mapFunction.init();
            }
        }

        if ($parentSection.hasClass('cart-section')) {
            if ($('.block__featured_collection').length) {
                featuredCollectionSection.init();
            }
        }

        if ($parentSection.hasClass('product-template')) {
            
        }
    });

$(document)
    .on('shopify:block:deselect', function (e) {

        var $parentSection = $('#shopify-section-' + e.detail.sectionId);

        if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
            sliderBlock.deselect($parentSection)
        }

    });

$(document)
    .on('shopify:section:reorder', function (e) {

        utils.pageBannerCheck();

    });

$(document)
    .on('shopify:section:load', function (e) {

        var $parentSection = $('#shopify-section-' + e.detail.sectionId);

        utils.pageBannerCheck();

        

        if ($parentSection.hasClass('image-gallery-section')) {
            gallery.init($parentSection);
        }

        if ($parentSection.hasClass('social-feeds-section')) {
            $('.social-feeds-wrap').each(function (index, value) {

                social.twitter();

                var $target = $(this).find(".js-instafeed");
                instagram.loadContent({
                    el: $target,
                    clientID: $target.data('client-id'),
                    limit: $target.data('count'),
                    column: $target.data('column')
                });
            });
        }

        if ($parentSection.hasClass('faq-section')) {
            faqAccordion.init();
        }

        if ($parentSection.hasClass('cart-section')) {
            cart.init();
            if ($('.block__featured_collection').length) {
                featuredCollectionSection.init();
            }
        }

        if ($parentSection.hasClass('featured-promotions-section')) {
            featuredPromotions.init();
        }

        if ($parentSection.hasClass('slideshow-section')) {
            slideshow.init();
        }

        
        if ($parentSection.hasClass('search-section')) {
            searchAutocomplete.init();
        }
        


        if ($parentSection.hasClass('testimonial-section')) {
            testimonial.init();
        }

        if ($parentSection.hasClass('featured-products-section')) {
            productPage.initializeQuantityBox();
            productPage.productSwatches();
            productPage.init();
            
        }

        if ($parentSection.hasClass('map-section')) {
            mapFunction.init();
        }

        if ($parentSection.hasClass('featured-collection-section')) {
            featuredCollectionSection.init();
        }

        if ($parentSection.hasClass('video-section')) {
            videoSection.init();
        }

        if ($parentSection.hasClass('recently-viewed__section')) {
            recentlyViewed.init();
        }

        if ($parentSection.hasClass('product-template')) {
            productPage.init();
            productPage.productSwatches();
            productPage.relatedProducts();
            recentlyViewed.init();
            
        }

        if ($parentSection.hasClass('article-template-section')) {
            if (window.location.pathname.indexOf('/comments') != -1) {
                $('html,body').animate({scrollTop: $("#new-comment").offset().top - 140}, 'slow');
            }
        }

        if ($parentSection.hasClass('collection-template-section')) {
            collectionSidebarFilter.init();
        }

        if ($parentSection.hasClass('contact-section')) {
            mapFunction.init();
        }

        if ($parentSection.hasClass('search-template-section')) {
            
            searchAutocomplete.init();
            
            collectionSidebarFilter.init();
        }

        if ($parentSection.hasClass('header-section')) {
            header.init();
            header.loadMegaMenu();
        }

        if ($parentSection.hasClass('mega-menu-section')) {
            header.loadMegaMenu();
        }

        if ($parentSection.hasClass('page-details-section')) {
            featuredCollectionSection.init();
            videoSection.init();
            if ($('.block__image_gallery').length) {
                gallery.init();
            }
            ;
            recentlyViewed.init();
        }

        if ($parentSection.hasClass('product-details-section')) {
            featuredCollectionSection.init();
            videoSection.init();
            mapFunction.init();
            if ($('.block__image_gallery').length) {
                gallery.init();
            }
            ;
            recentlyViewed.init();
        }
        if ($parentSection.hasClass('countdown-section')) {
            countdown.init();
        }

    });


$(document)
    .on('shopify:section:unload', function (e) {

        var $target = $(e.target);
        var $parentSection = $('#shopify-section-' + e.detail.sectionId);

        if ($parentSection.hasClass('header-section')) {
            header.unload($target);
            header.unloadMegaMenu();
        }

        if ($parentSection.hasClass('slideshow-section')) {
            slideshow.unload($target);
        }

        if ($parentSection.hasClass('testimonial-section')) {
            testimonial.unload($target);
        }

        if ($parentSection.hasClass('video-section')) {
            videoSection.unload($target);
        }

        if ($parentSection.hasClass('search-section')) {
            searchAutocomplete.unload($target);
        }

        if ($parentSection.hasClass('product-template')) {
            productPage.unload($target);
        }

        if ($parentSection.hasClass('mega-menu-section')) {
            header.unloadMegaMenu();
        }

        if ($parentSection.hasClass('page-details-section')) {
            videoSection.unload($target);
        }

        if ($parentSection.hasClass('product-details-section')) {
            videoSection.unload($target);
        }

    });

$(document)
    .on('shopify:section:select', function (e) {

        var $parentSection = $('#shopify-section-' + e.detail.sectionId);

        if ($parentSection.hasClass('social-feeds-section')) {
            $('.social-feeds-wrap').each(function (index, value) {
                social.twitter();
            });
        }

        if ($parentSection.hasClass('mega-menu-section')) {
            var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
            setTimeout(function () {
                $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
                $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
                header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
            }, 10);
        }

        if ($parentSection.hasClass('featured-collection-section')) {
            featuredCollectionSection.unload($parentSection);
            featuredCollectionSection.init();
        }

        utils.pageBannerCheck();
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
    });

$(document)
    .on('shopify:section:deselect', function (e) {

        var $parentSection = $('#shopify-section-' + e.detail.sectionId);

        if ($parentSection.hasClass('mega-menu-section')) {
            var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
            $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
            $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
        }
    });
$(function () {
    $('body').on('click', '.mobile-tab__header a', function (e) {
        e.preventDefault();
        var el = '#' + $(this).attr("data-index");
        $('.mobile-tab__header a').removeClass('parent-link--active');
        $(this).addClass('parent-link--active');
        $('.mobile-tab__content .submenu').removeClass('submenu--active');
        $(el).addClass('submenu--active');
    });
    $('.related-products--grid .product-list').flickity({
        cellSelector: '.column',
        groupCells: true,
        cellAlign: 'left',
        arrowShape: 'M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z'


    });
    $('body').on('click', '.js-mobile-tab__toogle', function (e) {
        if ($(window).width() <= 798) {
            var parent = $(this).parents('.mobile-tab');
            var content = parent.find('.js-mobile-tab__content');
            content.slideToggle(300);
            $(this).toggleClass('is-open');
        }
    });
    $('body').on('click', '.filter__toogle, .filter__close, .bc-sf-filter-select-button,.bc-sf-filter-clear', function (e) {
        if ($('#header.mobile_nav-fixed--true .top_bar').hasClass('is-stiky')) {
            $('.filter__wrap-content').css('top', '40px');
        } else {
            $('.filter__wrap-content').css('top', $('#header.mobile_nav-fixed--true').outerHeight());
        }
        if ($(window).width() <= 798) {
            if ($('.filter__wrap-content').hasClass('is-open')) {
                $('html').removeClass('is--locked');
            } else {
                $('html').addClass('is--locked');

                /*$('#bc-sf-filter-block-title-product-type  a').addClass('.selected');
                $('#bc-sf-filter-block-content-product-type').show();*/
            }
            $('.filter__wrap-content').toggleClass('is-open');
        }
    });
    var scrollTop = $(window).scrollTop();
    if (scrollTop > $('#header.mobile_nav-fixed--true').height()) {
        $('#header.mobile_nav-fixed--true .top_bar').addClass('is-stiky');
        $('body').addClass('is-stiky-header');
        $('.dropdown_container--mobile_menu').css('top', 40).height($(window).height() - 40);

    } else {
        $('#header.mobile_nav-fixed--true .top_bar').removeClass('is-stiky');
        $('body').removeClass('is-stiky-header');
        $('.dropdown_container--mobile_menu').css('top', $('#header.mobile_nav-fixed--true').outerHeight() - scrollTop).height($(window).height() - $('#header.mobile_nav-fixed--true').outerHeight() - scrollTop);
    }

    function isInView(elem) {
        var $elem = $(elem);
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    $(window).scroll(function () {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > $('#header.mobile_nav-fixed--true').height()) {
            $('#header.mobile_nav-fixed--true .top_bar').addClass('is-stiky');
            $('body').addClass('is-stiky-header');
            $('.dropdown_container--mobile_menu').css('top', 40).height($(window).height() - 40);
        } else {
            $('#header.mobile_nav-fixed--true .top_bar').removeClass('is-stiky');
            $('body').removeClass('is-stiky-header');
            $('.dropdown_container--mobile_menu').css('top', $('#header.mobile_nav-fixed--true').outerHeight() - scrollTop).height($(window).height() - $('#header.mobile_nav-fixed--true').outerHeight() - scrollTop);
        }

    });

    // $('body').on('click','.bc-sf-filter-option-item',function (e) {
    // console.log($(this).closest('.bc-sf-filter-block-content-inner').siblings('.bc-sf-filter-select-button'));
    // $(this).parents('.bc-sf-filter-block-content-inner').find('.bc-sf-filter-select-button').trigger('click');
    // $(this).closest('.bc-sf-filter-block-content-inner').siblings('.bc-sf-filter-select-button').trigger('click');
    // });

    $('[data-auth-tab]').on('click', function (e) {
        e.preventDefault();
        $('[data-auth-tab]').removeClass('is--active');
        $(this).addClass('is--active');
        $('.customer-auth-login, .customer-auth-signup').removeClass('is--active').filter('.' + $(this).data('auth-tab')).addClass('is--active');
    });

    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }

    function getCookie(name) {
        const matches = document.cookie.match(
            new RegExp(
                '(?:^|; )' + name.replace(/([.$?*|{}()[]\/\+^])/g, "\\$1") + '=([^;]*)'
            )
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    $('body').on('click', '.js-accordion-toggle', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-open');
        var el = $($(this).attr('href'));
        if (el.length > 0) {
            el.slideToggle(300);
        }
        s
    });
});
/*============================================================================
Product notify
==============================================================================*/
$(document).ready(function () {
    function updateURLParameter(url, param, paramVal) {
        var TheAnchor = null;
        var newAdditionalURL = "";
        var tempArray = url.split("?");
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = "";
        if (additionalURL) {
            var tmpAnchor = additionalURL.split("#");
            var TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];
            if (TheAnchor)
                additionalURL = TheParams;
            tempArray = additionalURL.split("&");
            for (var i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }
        else {
            var tmpAnchor = baseURL.split("#");
            var TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];
            if (TheParams)
                baseURL = TheParams;
        }
        if (TheAnchor)
            paramVal += "#" + TheAnchor;
        var rows_txt = temp + "" + param + "=" + paramVal;
        return baseURL + "?" + newAdditionalURL + rows_txt;
    }

    $('body').on('click', '.swatch-element label', function () {
        new_url = updateURLParameter(window.location.href, "variant", $(this).parent().attr('data-id'));
        history.pushState({}, null, new_url);
    });

    $('body').on('click', '.related-product-modal--close', function (e) {
        e.preventDefault();
        $('.related-product-modal--container.active').removeClass('active');
    });

    $('body').on('click', '.related-product-modal--container', function (event) {
        if ($(event.target).hasClass('related-product-modal--container')) {
            $(event.target).removeClass('active');
        }
    });
});

/**
 * License restriction
 */

function restrictLicenses() {
    var geoip = "https://minerva.bravafabrics.com/geolocate"
    let allowedCountries = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "GB", "MC", "SM", "VA", "NO", "LI", "IS", "AD", "CH", "IE", "IS"];
    $.getJSON(geoip, function (response) {
        if (!allowedCountries.includes(response.result.code)) {
            jQuery('.license-disclaimer').show();
            jQuery('.eu-license').hide();
        }
    });
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
var vh = window.innerHeight * 0.01;

// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', (vh + 'px'));
// We listen to the resize event
window.addEventListener('resize', function () {
    // We execute the same script as before
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', (vh + 'px'));
});
